var map = {
	"./hidden_en.png": "MHcj",
	"./hidden_fr.png": "qHSz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wcCQ";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/assets ^\.\/hidden_.*\.png$
// module id = wcCQ
// module chunks = 0